import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import { ErrorBoundary } from "./ui/ErrorBoundary.tsx";
import "leaflet/dist/leaflet.css";
// Self-hosted app typeface (UI redesign phase 1) — no request to any font
// CDN, so the app keeps working fully offline. Only the weights actually
// used by the type scale in base.css (see --weight-* there).
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/600.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import "./styles/base.css";
import "./styles/landing.css";
import "./styles/workspace.css";
import "./styles/networkMap.css";
import "./styles/elementBrowser.css";
import "./styles/propertyPanel.css";
import "./styles/resultsDashboard.css";
import "./styles/popovers.css";
import "./styles/dialog.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
